// extracted by mini-css-extract-plugin
module.exports = {"successLoginSSO":"success-sso-login_successLoginSSO__pWpio","successLoginSSOCo":"success-sso-login_successLoginSSOCo__2aTZi","Title":"success-sso-login_Title__2Is4i"};